import { type RefObject, useLayoutEffect, useRef } from "react";
import type { ListImperativeAPI } from "react-window";
import type { OptionItemData } from "../../PitSelector.types";

export const useScrollToSelectedOption = (
  itemData: OptionItemData[],
  internalListRef: RefObject<ListImperativeAPI | null>
) => {
  const scrolledToSelectedRef = useRef(false);
  const scrollToSelected = () => {
    if (scrolledToSelectedRef.current) return;
    const list = internalListRef.current;
    if (!list?.element) return;
    const selectedIndex = itemData.findIndex(
      ([optionProps]) => optionProps?.["aria-selected"]
    );
    if (selectedIndex < 0) return;
    list.scrollToRow({ index: selectedIndex, align: "auto" });
    scrolledToSelectedRef.current = true;
  };

  // shortcut: scroller element lands a state update later, so microtask + onRowsRendered retry; drop the microtask if open still flashes the list top
  useLayoutEffect(() => {
    scrollToSelected();
    queueMicrotask(scrollToSelected);
  }, [itemData, internalListRef]);

  return scrollToSelected;
};
